import Model from 'src/models/model'

export default class CeaCard extends Model {
  static name = 'CeaCard'

  static noId = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Promotions, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      valid: {
        type: Boolean,
        default: false,
        output: true
      },
      error: {
        type: String,
        default: null,
        output: true
      },
      cardNumber: {
        type: String,
        default: null,
        input: true
      }
    }
  }
}
